// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__F5ghH","title":"styles_title__2FdMG"};